const getters = {
  readCount: state => state.app.count.readCount,
  projectName: state => state.app.projectName,
  loginFlag: state => state.app.loginFlag,
  isSign: state => state.app.behavior.isSign,
  userInfo: state => state.app.userInfo,
  hideFlag: state => state.app.hideFlag,
  sysTime: state => state.app.sysTime,
  registerFlag: state => state.app.registerFlag,
  isPraise: state => state.app.behavior.isPraise,
  isScore: state => state.app.behavior.isScore,
  canJoin: state => state.app.behavior.canJoin,
  canCollect: state => state.app.behavior.canCollect,
  breadId: state => state.app.breadId,
  loadingFlag: state => state.app.loadingFlag,
  thirdUser: state => state.app.thirdUser,
  hideBottomFlag: state => state.app.hideBottomFlag,
  teamUser: state => state.app.teamUser,
  comment_flg: state => state.app.comment_flg,
  menuIndex: state => state.app.menuIndex,
  uploadcount: state => state.app.uploadcount,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js